<div id="rollin-review-card">
    <div class="header d-flex flex-row">
        <div class="title p-0">{{_rollin.nameOfSuperFund}}</div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">USI</div>
        <div>{{_rollin.usi}}</div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">Member number</div>
        <div>{{_rollin.memberNumber}}</div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">Amount</div>
        <div *ngIf="_rollin.wholeAmount === 1">Whole balance</div>
        <div *ngIf="_rollin.wholeAmount === 2">{{_rollin.amountToTransfer | currency}} (Partial)</div>
    </div>
</div>